import TranslateIcon from "@mui/icons-material/Translate";
import React, { useState } from "react";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageSelectorModal from "../LanguageSelectorModal";

export default function LanguageSelector({ isDrawerOpen, listItemIconStyles }) {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [language, setLanguage] = useState(i18n.language);
  const languageList = i18n.options.resources;

  const handleChange = (event) => {
    const lang = event.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
    window.localStorage.setItem("languageSet", lang);
  };

  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  if (!isDrawerOpen) {
    return (
      <>
        <ListItemIcon sx={listItemIconStyles} onClick={handleIconClick}>
          <TranslateIcon color="black" />
        </ListItemIcon>
        <LanguageSelectorModal
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
        />
      </>
    );
  }

  return (
    <Grid container alignItems="center" sx={{ width: "auto", px: 2 }}>
      <FormControl variant="outlined" sx={{ minWidth: 120 }}>
        <Select
          value={language}
          onChange={handleChange}
          displayEmpty
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            boxShadow: 1,
            ".MuiSelect-select": {
              py: 1.2,
              px: 2,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#2879A8",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#2879A8",
              borderWidth: "2px",
            },
          }}
        >
          {Object.keys(languageList).map((l) => (
            <MenuItem key={l} value={l}>
              {languageList[l].name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
}
